/* eslint-disable react/require-default-props */
import React from 'react';
import { MdPerson } from 'react-icons/md';

import { StyledContainer, StyledAvatar } from './styles';

interface AvatarInterface {
  name?: string;
  image?: string;
  size?: number;
  variant?: 'primary' | 'secondary';
}

function Avatar({
  name = '',
  image = '',
  size = 40,
  variant = 'primary',
}: AvatarInterface) {
  const initials = name
    ?.split(/\s/)
    .map((part) => part.substring(0, 1).toUpperCase())
    .filter((v) => !!v)
    .slice(0, 2)
    .join('')
    .toUpperCase();

  return (
    <StyledContainer>
      <StyledAvatar image={image} size={size} variant={variant}>
        {!image && (initials || <MdPerson size={(size * 2) / 3} />)}
      </StyledAvatar>
    </StyledContainer>
  );
}

export default Avatar;
